import {
  Button,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
  Box
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { buy_nfts, cancel_nft_sell } from "../../keychain/login";
import { rutas } from "../../rutas/rutas";

export const Marketlace = () => {
  const { usuario, especiales = [], generalNft = [] } = useSelector((state) => state.userSlice);

  const [selector, setSelector] = useState(null);
  const [open2, setOpen2] = useState(false);
  const [cartas, setCartas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cargado, setCargado] = useState(false);
  const dispatch = useDispatch();

  const handleClose2 = () => {
    setOpen2(false);
    setSelector(null);
  };

  const handleTransform = (market = []) => {
    const deck = [...especiales, ...generalNft];
    const venidadPorJuego = [105];

    if (deck.length === 0) {
      console.warn("Deck base vacío, no se pueden mapear los NFTs correctamente");
    }

    const deckprueba = market.reduce((acum, nft) => {
      const id = parseInt(nft?.grouping?.ID);
      if (!id) return acum;

      const cartaBase = deck.find((card) => card?.ide === id);
      if (!cartaBase) return acum;

      const indexExistente = acum.findIndex((card) => card.ide === id);

      if (indexExistente === -1) {
        return [
          ...acum,
          {
            ...cartaBase,
            nft: [{
              grupo: nft.grouping,
              nftId: nft.nftId,
              precio: nft.price,
              simbolo: nft.priceSymbol,
              vendedor: nft.account
            }]
          }
        ];
      } else {
        return acum.map((carta) =>
          carta.ide === id
            ? {
                ...carta,
                nft: [
                  ...carta.nft,
                  {
                    grupo: nft.grouping,
                    nftId: nft.nftId,
                    precio: nft.price,
                    simbolo: nft.priceSymbol,
                    vendedor: nft.account
                  }
                ]
              }
            : carta
        );
      }
    }, []);

    return deckprueba.sort((a, b) =>
      venidadPorJuego.includes(a.ide) ? -1 : venidadPorJuego.includes(b.ide) ? 1 : 0
    );
  };

  const getCard = () => {
    setLoading(true);
    axios
      .post(`${rutas.smartContract}`, {
        jsonrpc: "2.0",
        id: 1,
        method: "find",
        params: {
          contract: "nftmarket",
          table: "NFTHUESOsellBook",
          query: {},
          limit: 1000,
          offset: 0,
          indexes: []
        }
      })
      .then((res) => {
        const deckSave = res?.data?.result || [];
        if (deckSave.length === 0) {
          console.warn("Respuesta vacía del market, reintentando en 3 segundos");
          setTimeout(getCard, 3000);
        }

        const transformed = handleTransform(deckSave);
        setCartas(transformed);
        setLoading(false);
        setCargado(true);
      })
      .catch((err) => {
        console.error("Error al obtener cartas del smart contract:", err);
        setCartas([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if ((especiales.length > 0 || generalNft.length > 0) && !cargado) {
      getCard();
    }
  }, [especiales, generalNft, cargado]);

  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", overflow: "auto" }}>
      {loading ? (
        <CircularProgress color="inherit" />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            height: "50%",
            alignContent: "flex-start",
            justifyContent: "flex-start"
          }}
        >
          {cartas.map((carta) => (
            <Box
              sx={{ width: "110px", height: "170px", margin: "10px", position: "relative" }}
              key={uuidv4()}
            >
              <CardMedia
                component="img"
                image={carta?.url || ""}
                alt="Carta"
                sx={{ width: "110px", height: "190px", cursor: "pointer" }}
                onClick={() => {
                  setSelector(carta);
                  setOpen2(true);
                }}
              />
              <Typography
                sx={{
                  background: carta?.id?.[0] === "E" ? "#2B21DE" : "#F50202",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "20px",
                  height: "21px",
                  borderRadius: "50%",
                  textAlign: "center",
                  color: "white"
                }}
              >
                {carta?.id?.[0] || "?"}
              </Typography>
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: carta?.id?.[0] === "E" ? "#2B21DE" : "#F50202",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  textAlign: "center",
                  color: "white"
                }}
              >
                {carta?.rareza?.toUpperCase() || "?"}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {open2 && selector && (
        <Dialog open={open2} onClose={handleClose2}>
          <DialogContent
            sx={{
              bgcolor: "background.paper",
              width: { xs: "260px", sm: "350px", md: "450px", lg: "500px" },
              height: { xs: "500px", sm: "450px", md: "400px", lg: "400px" },
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
              <Box sx={{ width: "50%", height: "100%" }}>
                <CardMedia
                  component="img"
                  image={selector?.url || ""}
                  alt="Detalle Carta"
                  sx={{ width: "100%", cursor: "pointer" }}
                />
              </Box>

              <Box
                sx={{
                  height: "100%",
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <Box sx={{ height: "90%", width: "100%", overflow: "auto" }}>
                  {selector?.nft?.length > 0 ? (
                    selector.nft.map((nft) => (
                      <Box
                        key={uuidv4()}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid gray"
                        }}
                      >
                        <Typography sx={{ color: "white" }}>
                          Price: {parseFloat(nft.precio).toFixed(2)} {nft.simbolo}
                        </Typography>
                        {usuario?.user !== nft.vendedor ? (
                          <Button
                            onClick={() =>
                              buy_nfts(nft.nftId, nft.precio, nft.simbolo, "comprar")
                            }
                          >
                            Buy
                          </Button>
                        ) : (
                          <Button onClick={() => cancel_nft_sell(nft.nftId)}>Cancel</Button>
                        )}
                      </Box>
                    ))
                  ) : (
                    <Typography>No NFTs disponibles</Typography>
                  )}
                </Box>
                <Button sx={{ height: "10%" }} fullWidth variant="contained" onClick={handleClose2}>
                  Close
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};
